import { ConsignmentAgreementSnsPlatform } from 'types/oms';

export const CONSIGNMENT_AGREEMENT_SNS_OPTIONS: Array<{
  value: ConsignmentAgreementSnsPlatform;
  label: string;
}> = [
  { value: 'all', label: '全て掲載可' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'wechat', label: 'WeChat' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'red', label: '小紅書/RED' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'website', label: '弊社Webサイト' },
];

export const CONSIGNMENT_AGREEMENT_SNS_LABELS: Record<
  ConsignmentAgreementSnsPlatform,
  string
> = {
  all: '全て掲載可',
  instagram: 'Instagram',
  wechat: 'WeChat',
  whatsapp: 'WhatsApp',
  red: '小紅書/RED',
  youtube: 'YouTube',
  website: '弊社Webサイト',
};

export const CONSIGNMENT_AGREEMENT_UI = {
  back: '戻る',
  notReady: '委託販売が確定していないため、署名できません',
  bringInNo: 'お持込No.',
  sns: 'SNS・Web掲載許可',
  snsMultiple: '複数選択可',
  signedAt: '署名日時',
  signedDate: '署名日',
  hint: '枠内に署名してください',
  clear: '署名をクリア',
  sign: '署名して完了',
  print: '印刷する',
  edit: '修正する',
  cancelEdit: 'キャンセル',
  agreeRequired: '規約への同意が必要です',
  success: '署名しました',
  updateSuccess: '更新しました',
};

export const CONSIGNMENT_AGREEMENT = {
  title: '委託販売（商品のお預かり）規約',
  preamble:
    'ASU BRAND株式会社（以下「当社」といいます）が運営・提供するすべてのサービス（以下、「本サービス」といいます）における利用条件を定めるものです。お客様は本規約に従って、本サービスをご利用するものとします。また、お申込みされた時点で本規約にすべて同意したものといたします。',
  articles: [
    {
      no: 1,
      title: 'サービスの利用について',
      paragraphs: [
        '本サービスは18歳未満（高校生を含む）の方のご利用はできません。',
      ],
    },
    {
      no: 2,
      title: '取扱商品',
      paragraphs: [
        '1. 本サービスにおいて取り扱う商品は当社取り扱いブランドのバッグ、サイフ、小物、時計、アクセサリー、ノーブランドジュエリー、その他当社が定めた商品のみとなります。',
        '2. 以下に該当する商品はお取り扱いできません。',
        '・コピー商品、偽造品、模造品など。',
        '・盗難品、その他法令に抵触する恐れのあるもの。',
        '・当社の取り扱い基準に満たないもの。',
      ],
    },
    {
      no: 3,
      title: '商品の送付について',
      paragraphs: [
        '1. 商品の送付前に、電話やホームページでのお申し込みが必要となります。',
        '2. 商品を当社にお送りいただく際の送料は、当社の負担となります。',
        '3. お客様は商品配送中の故障・破損等の事故防止のため、当社が用意する宅配キットを使用し、可能な限り厳重に梱包するものとする。',
        '4. 当社への配送中商品に、故障・破損・紛失などがありましても、当社は一切の責任を負わないものとする。',
      ],
    },
    {
      no: 4,
      title: '委託販売契約について',
      paragraphs: [
        '1. 店頭、お電話、またはホームページよりお申し込みをいただきます。',
        '2. 商品をご送付いただく場合、当社がお客様のご自宅に宅配キットをお送りし、お客様は到着した宅配キットを使用し商品を発送するものとします。',
        '3. 当社へ商品が到着後、当社の査定担当が検品、査定および市場価格調査をした上で商品売却時にお支払する金額をご提示します。',
        '4. 商品の発送及びご返送の送料は当社が負担いたします。',
      ],
    },
    {
      no: 5,
      title: '販売代金のお支払いについて',
      paragraphs: [
        'お支払いは、売却日より約10日から15日後となります。通信販売及びWEBサイトでの販売はクーリングオフ制度が適用されるため、成約確定後15日後となります。お振込みでのお支払いをご希望の場合、15日後以降の金融機関営業日といたします。',
      ],
    },
    {
      no: 6,
      title: '委託販売キャンセルについて',
      paragraphs: [
        '委託販売中のキャンセルについては、お申し出いただければ可能です。ただし当該の商品がすでに商談中やお取り置きとなっている場合はキャンセルをお受けできません。また、買取への変更をご希望であれば可能ですが、買取価格は変更希望時点での当社既定の買取相場に基づいて改めて査定を行い、買取価格を決定するものとします。',
      ],
    },
    {
      no: 7,
      title: '商品の取り扱いについて',
      paragraphs: [
        '1. 商品が未開封の場合でも、商品の検品、査定を行うため開封いたします。ラッピング等もとに戻せない場合があります。',
        '2. お預かりした商品は、手袋着用でお取り扱いし、保管状態も万全の状態で管理いたします。',
      ],
    },
    {
      no: 8,
      title: '保証・弁償について',
      paragraphs: [
        '1. 商品をお預かりした後、未売却や委託販売キャンセルなど、お客様に返品をする際、お預かりした状態を大きく逸脱した破損や劣化があった場合、売却時にお支払いをお約束している金額を上限として補償いたします。しかしながら、当社に故意、または重大な過失がある場合適用するが、自然な劣化や過失の無い微細な破損に関してはこの限りではありません。',
        '2. 商品お預かり後、商品の紛失及び火災、事故などで、著しく商品が破損した場合、売却時にお支払いをお約束している金額を上限として補償いたします。',
      ],
    },
    {
      no: 9,
      title: '個人情報のお取り扱いについて',
      paragraphs: [
        'お客様の許可なくお客様の個人情報を第三者に提供することはありません。但し、古物営業法上の取引記録、またはご本人確認、警察など行政からの正式要請に応じるための情報提供などの場合は、その限りではありません。',
      ],
    },
    {
      no: 10,
      title: '商品情報のお取り扱いについて',
      paragraphs: [
        '委託期間中に作成した商品情報及び画像は、委託期間中、委託販売キャンセル後、委託販売終了後も当社ASU BRAND株式会社が所有するものとし、お客様は当社が販売実績やお取り扱い商品履歴として、その商品情報を永年使用する事を許可するものとする。',
      ],
    },
    {
      no: 11,
      title: '当該商品のSNS掲載について',
      paragraphs: [
        '委託でお預かりした商品を、下記SNSサービス掲載を許可します。',
      ],
    },
  ],
  footer: {
    address: '東京都中央区銀座1-8-21 第21中央ビル1F・2F',
    tel: '03-6228-6598',
    company: 'ASU BRAND株式会社',
    shopName: 'XIAO MA 銀座中央通り本店',
    consentLabel: '上記規約を確認し、内容に同意します。',
    printConsent: '上記全てに同意いたします。',
    signature: 'ご署名',
    staff: '担当者',
    seal: '印',
  },
};
